import { Button, Sheet } from "@rhema/ui";

/** What the encryption notice at the top of a chat says. The sheet behind it has the details. */
export const ENCRYPTION_NOTICE =
  "Messages are end-to-end encrypted. Your history is backed up so you can get it back. Tap to learn more.";

/**
 * How messages are protected and how a person gets their history back, opened from the notice at
 * the top of every chat. Since 2026-10-27 Rhema support can help recover history unless the person
 * turns on advanced protection, so this says so plainly.
 */
export function EncryptionSheet({
  open,
  onClose,
  onVerify,
}: {
  open: boolean;
  onClose: () => void;
  /** Opens the chat's details, where the safety numbers are. */
  onVerify?: () => void;
}) {
  return (
    <Sheet open={open} onClose={onClose} title="Encryption and your backup" className="px-5 pb-7">
      <ul className="m-0 mt-3 flex list-disc flex-col gap-2 pl-5 text-[15px] leading-normal text-ink-secondary">
        <li>Messages and calls are end-to-end encrypted on your device before they are sent.</li>
        <li>
          Rhema keeps an encrypted backup of your message keys, so you can get your history back on a new
          device.
        </li>
        <li>Your backup PIN restores your history if you lose every device.</li>
        <li>
          If you lose every device and forget your backup PIN, Rhema support can help you recover your history
          after checking who you are.
        </li>
        <li>
          You can turn that off with Advanced protection in Settings, under Chats. Then only your devices and
          your backup PIN can restore your history.
        </li>
      </ul>
      <div className="mt-5 flex flex-col gap-2">
        {onVerify && (
          <Button
            variant="outline"
            onClick={() => {
              onClose();
              onVerify();
            }}
          >
            Check safety numbers
          </Button>
        )}
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
      </div>
    </Sheet>
  );
}
